import { createSlice } from '@reduxjs/toolkit';
import { isServerSideRendering } from '@dbh/environment';

/*
 *
 * Constants: `@dbh/front-end-logic-redirect-redux`.
 *
 */const REDUX_AND_SAGA_KEY="frontEndLogicRedirect";

const initialState={redirectTo:void 0,statusCode:void 0,redirectLogic:void 0,redirectToUrlOfWebpagesRoute:void 0},frontEndLogicRedirectSlice=createSlice({name:REDUX_AND_SAGA_KEY,initialState,reducers:{frontEndLogicRedirectTriggered:(a,b)=>{if(!isServerSideRendering())// In the browser we execute the redirect immediately, in the browser
// only saga, when `frontEndLogicRedirectTriggered` is dispatched.
return a;// In server side rendering we store it, then `makeSelectRedirectData`
// uses `makeSelectFrontEndLogicRedirect` to extract the data.
const{payload:{statusCode:c,redirectLogic:d,redirectTo:e,redirectToUrlOfWebpagesRoute:f}}=b;return {statusCode:c,redirectLogic:d,// Don't add `redirectTo: undefined`, it triggers our `withConformsTo`
// validator, sometimes without printing the error in the browser.
...(e?{redirectTo:e}:{}),// Don't add `redirectToUrlOfWebpagesRoute: undefined`, it triggers our
// `withConformsTo` validator, sometimes without printing the error in
// the browser.
...(f?{redirectToUrlOfWebpagesRoute:f}:{})}}}});const {frontEndLogicRedirectTriggered}=frontEndLogicRedirectSlice.actions;var reducer = frontEndLogicRedirectSlice.reducer;

var reducer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  frontEndLogicRedirectTriggered: frontEndLogicRedirectTriggered,
  'default': reducer,
  REDUX_AND_SAGA_KEY: REDUX_AND_SAGA_KEY
});

const selectStateSlice=a=>a[REDUX_AND_SAGA_KEY];var selectStateSlice$1 = selectStateSlice;

const makeSelectFrontEndLogicRedirect=()=>selectStateSlice$1;var makeSelectFrontEndLogicRedirect$1 = makeSelectFrontEndLogicRedirect;

/*
 *
 * Package: `@dbh/front-end-logic-redirect-redux`.
 *
 */const importFrontEndLogicRedirectBrowserOnlySagas=import('./index-a28aeff8.js'/* webpackChunkName: 'dbh.front-end-logic-redirect-redux.sagas' */);const importFrontEndLogicRedirectReducer=Promise.resolve().then(function () { return reducer$1; });

export { REDUX_AND_SAGA_KEY, frontEndLogicRedirectTriggered, importFrontEndLogicRedirectBrowserOnlySagas, importFrontEndLogicRedirectReducer, makeSelectFrontEndLogicRedirect$1 as makeSelectFrontEndLogicRedirect };
